import type { FeatureFlagProviderProps } from '@seek/candidate-feature-flag';
import { useMemo } from 'react';

import type { ConfigStateContext } from 'src/types';

import { launchDarklyExperiments } from '../domain/launchDarklyExperiments';
import { launchDarklyFeatureFlags } from '../domain/launchDarklyFeatureFlags';

export const useFeatureFlagProviderProps = (
  config: ConfigStateContext,
): Omit<FeatureFlagProviderProps, 'children'> => {
  const debug = config.environment !== 'production';

  return useMemo<Omit<FeatureFlagProviderProps, 'children'>>(
    () => ({
      featureFlagsConfig: launchDarklyFeatureFlags,
      experimentsConfig: launchDarklyExperiments,
      solId: config.solId,
      customContext: {
        applicationContext: {
          key: config.solId,
          namespace: 'career-hub-web',
          build: '1.0.0',
          version: '1.0.0',
        },
      },
      debug,
      shouldEnableOverride: true,
      overrideSource: config.launchDarklyOverrides,
    }),
    [config, debug],
  );
};
